import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Grid, Card } from "semantic-ui-react";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import CreateJobStore from "../stores/CreateJobStore";
import HDRCard from "./CreateJobPage/HDRCard";
import JobType from "~/constants/PhotoEditing/JobType";
import JobBreadcrumb from "../components/JobBreadcrumb";
import "../styles/CreateJob.less";

@observer
class CreateJobPage extends Component {
  createJobStore = null;

  constructor(props) {
    super(props);
    this.createJobStore = new CreateJobStore(props.tourId);
  }

  componentDidMount() {
    const { showError } = this.props;

    this.createJobStore.load().catch(error => showError(error.message));
  }

  createPhotoEditingJob(typeId) {
    const { photoEditingJobCreatedCallback, onViewJobCallback, showError } = this.props;

    if (typeId === JobType.BASIC_HDR) {
      const freeBasicHDRJobInCreation = this.createJobStore.findFreeBasicHDRJobInCreation();

      if (freeBasicHDRJobInCreation) {
        // redirect the user to the existing free basic hdr job that is still in creation
        onViewJobCallback(freeBasicHDRJobInCreation);

        // consistent return value type.
        return Promise.resolve();
      }
    }

    return this.createJobStore
      .createPhotoEditingJob(typeId)
      .then(response => {
        photoEditingJobCreatedCallback(response.data.photoEditingJob);
      })
      .catch(error => showError(error.message));
  }

  render() {
    const { isLoading } = this.createJobStore;
    const { viewJobsCallback } = this.props;

    if (isLoading) {
      return <ContentLoader />;
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <JobBreadcrumb viewJobsCallback={viewJobsCallback} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row textAlign="center">
          <Grid.Column width={16}>
            <h3>Select The Type of Job You Need</h3>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row textAlign="center">
          <Grid.Column width={16}>
            <Card.Group itemsPerRow={2} centered>
              <HDRCard submitCallback={() => this.createPhotoEditingJob(JobType.BASIC_HDR)} />
            </Card.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

CreateJobPage.propTypes = {
  showError: PropTypes.func.isRequired,
  tourId: PropTypes.number.isRequired,
  photoEditingJobCreatedCallback: PropTypes.func.isRequired,
  viewJobsCallback: PropTypes.func.isRequired,
  // If user already created a basic hdr job and it is still in new, then whenever they try to create
  // a new basic hdr job, instead of letting them to create we'll redirect them to the existing one.
  // See NEST-496
  onViewJobCallback: PropTypes.func.isRequired,
};

export default ErrorWrapper(CreateJobPage);
